import {Component} from '@angular/core';
import {AddOffer, AddProduct, ProductService} from '@uofu-uss-aux/software-catalog-ng-core';
import {NgIf, TitleCasePipe} from '@angular/common';
import {UnderscoreToSpacePipe} from '../../formatting/underscore-to-space.pipe';

@Component({
  selector: 'app-purchase-title',
  templateUrl: './purchase-title.component.html',
  styleUrls: ['./purchase-title.component.scss'],
  inputs: ['product', 'offer'],
  standalone: true,
  imports: [
    NgIf,
    TitleCasePipe,
    UnderscoreToSpacePipe
  ]
})
export class PurchaseTitleComponent extends AddProduct(AddOffer(Object)) {

  constructor(private readonly productService: ProductService) {
    super();
  }

  get licenseType() {
    return this.productService.findLicenseFromOffering(this.product, this.offer)?.type;
  }
}

